import { InMemoryCache, makeVar } from '@apollo/client'
import { getUser } from './services/auth'

export const hasWindow = typeof window !== 'undefined'

const initialLoginState = {
  phoneNumber: '',
  countryId: 2,
}

/**
 * Safely parse localStorage values that may contain malformed JSON
 * Fixes AD-6240: prevents "undefined" string literal from causing JSON.parse() errors
 */
const safeGetStorageValue = key => {
  if (!hasWindow) return null
  try {
    const value = window.localStorage.getItem(key)
    // If value is the literal string "undefined", remove it and return null
    // This handles cases where localStorage.setItem(key, undefined) was called
    if (value === 'undefined') {
      window.localStorage.removeItem(key)
      return null
    }
    // Attempt to parse as JSON for backward compatibility
    // If it's not valid JSON, return the raw value as-is
    if (value) {
      try {
        return JSON.parse(value)
      } catch (parseError) {
        // Value is not JSON, return as plain string
        return value
      }
    }
    return null
  } catch (error) {
    console.error(`Error reading localStorage key "${key}":`, error)
    return null
  }
}

export const isLoggedInVar = makeVar((hasWindow && !!getUser()?.user) || null)

export const selectedWalletVar = makeVar(
  safeGetStorageValue('selectedWallet') || null,
)

export const selectedContactVar = makeVar(
  safeGetStorageValue('selectedContact') || null,
)

export const selectedVoucherVar = makeVar(
  safeGetStorageValue('selectedVoucher') || null,
)
export const selectedSendVoucherVar = makeVar(
  safeGetStorageValue('selectedSendVoucher') || null,
)

export const selectedPartnerVar = makeVar(
  safeGetStorageValue('selectedPartner') || null,
)

export const countrySelectedInfoVar = makeVar(
  safeGetStorageValue('countrySelectedInfo') || null,
)

export const selectedTagVar = makeVar(
  (hasWindow && window.localStorage.getItem('selectedTag')) || null,
)

export const pushMoneyUserVar = makeVar(getUser() || null)

export const loginStateVar = makeVar(initialLoginState)

export const cache = new InMemoryCache({
  typePolicies: {
    Partner: {
      keyFields: ['id', 'aliasId'],
    },
    Query: {
      fields: {
        isLoggedIn: {
          read: () => {
            const isLoggedIn = isLoggedInVar()
            return isLoggedIn
          },
        },
        loginState: {
          read: () => {
            const loginState = loginStateVar()
            return loginState
          },
        },
        selectedTag: {
          read: () => selectedTagVar(),
        },
        selectedWallet: {
          read: () => {
            const selectedWallet = selectedWalletVar()
            return selectedWallet
          },
        },
        selectedContact: {
          read: () => selectedContactVar(),
        },
        selectedVoucher: {
          read: () => {
            const selectedVoucher = selectedVoucherVar()
            return selectedVoucher
          },
        },
        selectedSendVoucher: {
          read: () => {
            const selectedSendVoucher = selectedSendVoucherVar()
            return selectedSendVoucher
          },
        },
        selectedPartner: {
          read: () => {
            const selectedPartner = selectedPartnerVar()
            return selectedPartner
          },
        },
        pushMoneyUser: {
          read: () => {
            const pushMoneyUser = pushMoneyUserVar()
            return pushMoneyUser
          },
        },
        countrySelectedInfo: {
          read: () => {
            const countrySelectedInfo = countrySelectedInfoVar()
            return countrySelectedInfo
          },
        },
      },
    },
  },
})
